import {constants} from '@neosvoc/nv-platform-core-common';
import classNames from 'classnames';
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import config from '../../../../config';
import messages from '../../../../res/translations/messages';
import {organizationRequest} from '../../../actions/action_organization';
import {requestSurvey} from '../../../actions/action_survey';
import {
    requestSurveyTrackerDelete,
    requestSurveyTrackers,
    requestSurveyTrackersDelete,
    requestSurveyTrackersSave,
    requestSurveyTrackersSend,
    requestSurveyTrackersTest,
} from '../../../actions/action_survey_trackers';
import {TRACKER_FILTERS, TRACKERS_PAGE_SIZE} from '../../../constants';
import Alert from '../../Alert';
import Loader from '../../Loader';
import SurveyUploadEmailButton from '../SurveyUploadEmailButton';
import DeleteTrackersButton from './DeleteTrackersButton';
import SendMessageModalButton from './SendMessageModalButton';
import TrackerFilters from './TrackerFilters';
import TrackersList from './TrackersList';
import WaveToolbar from './WaveToolbar';


class WaveTrackers extends Component {
    constructor(props) {
        super(props);
        this.state = {filter: TRACKER_FILTERS.ALL, page: 1, total: 0, orderBy: null, filterText: '', loading: false};
        this.handleSendInvitation = this.handleSendMessage.bind(
            this,
            constants.TRACKER_MESSAGE_TYPES.INVITATION,
        );
        this.handleSendReminder = this.handleSendMessage.bind(
            this,
            constants.TRACKER_MESSAGE_TYPES.REMINDER,
        );
        this.handleSaveInvitation = this.handleSaveMessage.bind(
            this,
            constants.TRACKER_MESSAGE_TYPES.INVITATION,
        );
        this.handleSaveReminder = this.handleSaveMessage.bind(
            this,
            constants.TRACKER_MESSAGE_TYPES.REMINDER,
        );
        this.handleTestInvitation = this.handleTestMessage.bind(
            this,
            constants.TRACKER_MESSAGE_TYPES.INVITATION,
        );
        this.handleTestReminder = this.handleTestMessage.bind(
            this,
            constants.TRACKER_MESSAGE_TYPES.REMINDER,
        );
        this.handleTest = this.handleTestMessage.bind(
            this,
            constants.TRACKER_MESSAGE_TYPES.REMINDER,
        );
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleDeleteTracker = this.handleDeleteTracker.bind(this);
        this.handleDeleteTrackers = this.handleDeleteTrackers.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleFiltersChange = this.handleFiltersChange.bind(this);
    }

    componentDidMount() {
        this.props.requestSurveyTrackers(
            this.props.survey.id,
            this.props.match.params.waveId,
            this.state.page ? (this.state.page - 1) * TRACKERS_PAGE_SIZE : undefined,
            this.state.page ? TRACKERS_PAGE_SIZE : undefined,
        );
        this.props.organizationRequest();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.deleted && !prevProps.deleted) {
            const page = this.state.page - 1;
            this.setState({loading: false});
            this.props.requestSurveyTrackers(
                this.props.survey.id,
                this.props.match.params.waveId,
                this.state.page ? page * TRACKERS_PAGE_SIZE : undefined,
                this.state.page ? TRACKERS_PAGE_SIZE : undefined,
                this.state.orderBy ? this.state.orderBy : undefined,
                this.state.filter ? this.state.filter : undefined,
                this.state.filterText ? this.state.filterText : undefined,
            );
            return;
        }
        if (
            this.props.survey.id !== prevProps.survey.id ||
            this.props.match.params.waveId !== prevProps.match.params.waveId ||
            this.state.page !== prevState.page ||
            this.state.filter !== prevState.filter ||
            this.state.orderBy !== prevState.orderBy ||
            this.state.filterText !== prevState.filterText
        ) {
            let page = (this.state.page - 1);
            if (this.state.filter !== prevState.filter ||
                this.state.orderBy !== prevState.orderBy ||
                this.state.filterText !== prevState.filterText) {
                page = 0;
                this.setState({page: 1});
            }
            this.props.requestSurveyTrackers(
                this.props.survey.id,
                this.props.match.params.waveId,
                this.state.page ? page * TRACKERS_PAGE_SIZE : undefined,
                this.state.page ? TRACKERS_PAGE_SIZE : undefined,
                this.state.orderBy ? this.state.orderBy : undefined,
                this.state.filter ? this.state.filter : undefined,
                this.state.filterText ? this.state.filterText : undefined,
            );
        }
    }

    handleSendMessage(type, values) {
        this.props.requestSurveyTrackersSend(
            this.props.survey.id,
            this.props.match.params.waveId,
            Object.assign({type}, values),
        );
    }

    handleSaveMessage(type, values) {
        this.props.requestSurveyTrackersSave(
            this.props.survey.id,
            this.props.match.params.waveId,
            Object.assign({type}, values),
        );
    }

    handleTestMessage(type, values) {
        this.props.requestSurveyTrackersTest(
            this.props.survey.id,
            this.props.match.params.waveId,
            Object.assign({type}, values),
        );
    }

    handleFilterChange(value) {
        this.setState({filter: value});
    }

    handleDeleteTracker(trackerId) {
        this.setState({loading: true});
        this.props.requestSurveyTrackerDelete(
            this.props.survey.id,
            this.props.match.params.waveId,
            trackerId,
        );
    }

    handleDeleteTrackers() {
        this.setState({loading: true});
        this.props.requestSurveyTrackersDelete(
            this.props.survey.id,
            this.props.match.params.waveId,
        );
    }

    handleUpload() {
        const page = (this.state.page - 1);
        this.props.requestSurveyTrackers(
            this.props.survey.id,
            this.props.match.params.waveId,
            this.state.page ? page * TRACKERS_PAGE_SIZE : undefined,
            this.state.page ? TRACKERS_PAGE_SIZE : undefined,
            this.state.orderBy ? this.state.orderBy : undefined,
            this.state.filter ? this.state.filter : undefined,
            this.state.filterText ? this.state.filterText : undefined,
        );
    }

    handleChangePage(page) {
        this.setState({page});
    }
    handleFiltersChange(filterText, orderBy) {
        this.setState({filterText: filterText, orderBy: orderBy});
    }

    render() {
        const {survey, loading, error, results, trackers, organization, total} =
            this.props;
        const isLoading = loading || this.state.loading;
        const wave = survey.waves.find(
            ({id}) => id === this.props.match.params.waveId,
        );
        const warning =
            (trackers || [])
                .map((t) => t.messages.filter((m) => m.success === true).length > 0)
                .filter((val) => val === true).length > 0;
        return (
            (error && <Alert error={error} />) || (
                <>
                    {isLoading && <Loader />}
                    {!isLoading && trackers && organization && (
                        <>
                            <div className="mb-3">
                                <WaveToolbar survey={survey} wave={wave} warning={warning} />
                            </div>
                            {results && (
                                <div className="alert alert-success">
                                    <FormattedMessage
                                        {...messages.trackers.sendResults}
                                        values={results}
                                    />&nbsp;
                                    <FormattedMessage
                                        {...messages.trackers.sendResults.action[results.action]}
                                    />
                                </div>
                            )}
                            <TrackerFilters
                                status={this.state.filter}
                                initialFilterText={this.state.filterText ? this.state.filterText : ''}
                                initialSortingValue={this.state.orderBy ? this.state.orderBy : ''}
                                onChange={this.handleFilterChange}
                                onApplyFilters={this.handleFiltersChange}
                            />
                            <div className="my-3">
                                <TrackersList
                                    page={this.state.page}
                                    trackers={trackers}
                                    total={total}
                                    onDelete={this.handleDeleteTracker}
                                    onPageChange={this.handleChangePage}
                                />
                            </div>
                            <div className="row my-3">
                                <div className="col">
                                    <FormattedMessage {...messages.trackers.selectedCount} />{' '}
                                    <strong>{total}</strong>
                                </div>
                                {trackers.length > 0 && (
                                    <div className="col text-right">
                                        <DeleteTrackersButton
                                            onDelete={this.handleDeleteTrackers}
                                            wave={wave}
                                            warning={warning}
                                        >
                                            <button className="btn btn-primary delete-button"
                                                type="button"
                                            >
                                                <FormattedMessage
                                                    {...messages.trackers.buttons.deleteTrackers}
                                                />
                                            </button>
                                        </DeleteTrackersButton>
                                    </div>
                                )}
                            </div>
                            <div className="row">
                                <div className="col">
                                    <SurveyUploadEmailButton
                                        item={survey}
                                        wave={wave}
                                        className="mr-1 btn btn-outline-primary"
                                        onChange={this.handleUpload}
                                    >
                                        <FormattedMessage
                                            {...messages.trackers.buttons.uploadCsv}
                                        />
                                    </SurveyUploadEmailButton>
                                    <a href={
                                        trackers.length ?
                                            `${config.backofficeApiUrl}/survey/${survey.id}/wave/${wave.id}/trackers.csv` :
                                            undefined
                                    }
                                    download
                                    className={classNames('mx-1  btn btn-outline-primary', {
                                        disabled: !trackers.length,
                                    })}
                                    >
                                        <FormattedMessage
                                            {...messages.trackers.buttons.downloadCsv}
                                        />
                                    </a>
                                </div>
                                <div className="col text-right">
                                    <SendMessageModalButton
                                        className="btn btn-primary mr-1"
                                        onSubmit={this.handleSendInvitation}
                                        onSave={this.handleSaveInvitation}
                                        onTest={this.handleTestInvitation}
                                        extraFields={survey.extraFields}
                                        initialValues={survey.invitationTemplate}
                                        organization={organization}
                                        noTrackers={trackers.length === 0}
                                    >
                                        <FormattedMessage
                                            {...messages.trackers.buttons.sendInvitation}
                                        />
                                    </SendMessageModalButton>
                                    <SendMessageModalButton
                                        className="btn btn-primary"
                                        onSubmit={this.handleSendReminder}
                                        onSave={this.handleSaveReminder}
                                        onTest={this.handleTestReminder}
                                        extraFields={survey.extraFields}
                                        initialValues={survey.reminderTemplate}
                                        organization={organization}
                                        noTrackers={trackers.length === 0}
                                    >
                                        <FormattedMessage
                                            {...messages.trackers.buttons.sendReminder}
                                        />
                                    </SendMessageModalButton>
                                </div>
                            </div>
                        </>
                    )}
                </>
            )
        );
    }
}

const mapStateToProps = (state) => {
    return {
        survey: state.survey.item,
        loading:
            state.surveyTrackers.loading ||
            state.surveyTrackers.sending ||
            state.organization.loading,
        error: state.surveyTrackers.error,
        organization: state.organization.current,
        results: state.surveyTrackers.sendResults,
        trackers: state.surveyTrackers.items,
        total: state.surveyTrackers.total,
        deleted: state.surveyTrackers.deleted,
    };
};

export default connect(mapStateToProps, {
    requestSurvey,
    requestSurveyTrackers,
    requestSurveyTrackersSend,
    requestSurveyTrackerDelete,
    requestSurveyTrackersDelete,
    requestSurveyTrackersSave,
    requestSurveyTrackersTest,
    organizationRequest,
})(WaveTrackers);
